import { Box } from '@material-ui/core';
import { BusinessOnboardingDetails, formatMoney, getMoneySymbolByCurrency } from '@nemuru-eng/js-api-client';

import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { NumberFormField } from '@/components/shared/components/NewContextForms/NumberFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

interface BusinessFinancialDetailsFormProps extends FormGridOptions {
  businessDetails: BusinessOnboardingDetails['businessDetails'];
}

export const BusinessFinancialDetailsForm = ({
  businessDetails,
  fullWidth,
  fieldVariant,
}: BusinessFinancialDetailsFormProps) => {
  const isEditable = fieldVariant === FieldVariant.form;

  if (!businessDetails) return null;

  return (
    <Box pt={2}>
      <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
        <NumberFormField
          name={'capitalStock'}
          label={'CAPITAL_STOCK'}
          valueUnit={isEditable ? getMoneySymbolByCurrency(businessDetails.financialDetails.capitalStock.currency) : ''}
          value={
            businessDetails.financialDetails.capitalStock.amount &&
            formatMoney(amountToValueMoneyMapper(businessDetails.financialDetails.capitalStock))
          }
        />
        <NumberFormField
          name={'ownFunds'}
          label={'OWN_FUNDS'}
          valueUnit={isEditable ? getMoneySymbolByCurrency(businessDetails.financialDetails.capitalStock.currency) : ''}
          value={
            businessDetails.financialDetails.ownFunds &&
            formatMoney(amountToValueMoneyMapper(businessDetails.financialDetails.ownFunds))
          }
        />
        <NumberFormField
          name={'taxBase'}
          label={'TAX_BASE'}
          valueUnit={isEditable ? getMoneySymbolByCurrency(businessDetails.financialDetails.capitalStock.currency) : ''}
          value={
            businessDetails.financialDetails.taxBase &&
            formatMoney(amountToValueMoneyMapper(businessDetails.financialDetails.taxBase))
          }
        />
        <NumberFormField
          name={'individualFinancialNetAmount'}
          label={'INDIVIDUAL_FINANCIAL_NET_AMOUNT'}
          valueUnit={isEditable ? getMoneySymbolByCurrency(businessDetails.financialDetails.capitalStock.currency) : ''}
          value={
            businessDetails.financialDetails.individualFinancialNetAmount &&
            formatMoney(amountToValueMoneyMapper(businessDetails.financialDetails.individualFinancialNetAmount))
          }
        />
      </FormGridContainer>
    </Box>
  );
};
